/*
 * File Created: Wednesday, 7th December 2022 10:55:21 am
 * Author: Chenzier Kabrabam
 * Copyright (c) - 2018-2022 Addble Solutions Private Limited. All Rights Reserved.
 */

import { Theme, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';
import { Colors } from "../../constants/color";
import { staticData } from "../../data/staticData";
import { Icons } from "../../MediaIcon";
// import { CartContext } from "../../context/cartContext.context";
// import MediaIcon from '../../MediaIcon';
// import { useFetch } from '../../utils/useFetch.utils';

function SocialMedia(): JSX.Element {
  // const { name, description, links } = props;
  const theme: Theme = useTheme();

  const socialMedia = staticData.siteProfile.socialMedia.map((data) => {
    const iconData = Icons.find((icon) => icon.name === data.name)
    return (
      <Box
      key={data.name}
      component='a'
      href={data.src}
      sx={{
        width: "46px",
        height: "46px",
        borderRadius: "50%",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '20px',
        backgroundColor: iconData?.color,
        color: Colors.white,
        textDecoration: 'none',
        cursor: 'pointer',
        transition: "background-color 1000ms ease, color 900ms ease",
        "&:hover": {
          backgroundColor: Colors.white,
          color: iconData?.color,
          border: `1px solid ${Colors.dusty_gray}`,
        }
      }}
    >
      {iconData?.icon}
    </Box>
    )
  })

  return (
    <Box
      sx={{
        width: { xs: '100%', md: '49%' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: { xs: theme.spacing(6, 0), md: 0 },
      }}
    >
      <Box
        sx={{
          width: { xs: '100%', sm: '75%', md: '100%', xl: '68%' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: theme.spacing(0, 0, 4, 0),
          textAlign: 'center',
        }}
      >
        <Typography
          sx={{
            margin: theme.spacing(0, 0, 2, 0),
          }}
          variant='h5'
          fontWeight='bold'
        >
          Shop Social
        </Typography>
        <Typography variant='body1' fontSize='15px' color={Colors.boulder}>
          Connect with us
        </Typography>
      </Box>
      <Box
        sx={{
          // width: { xs: '80%', sm: '45%', md: '80%', xl: '50%' },
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'center',
          padding: theme.spacing(0.2),
          fontSize: '18px',
        }}
      >
        {socialMedia}
      </Box>
    </Box>
  );
};

export default SocialMedia;

// export const c = "sjsjs";